import { Injectable } from '@angular/core';
import * as moment from 'moment';

import { FoodPlanModel, UserModel } from '../../models/models';
import { ApiProvider } from '../api/api';

@Injectable()
export class FoodPlanProvider {
  private items: FoodPlanModel[] = [];

  constructor(
    private api: ApiProvider) {
  }

  async DeleteFoodItems(ids: number[]) {
    var promises = [];
    for (let id of ids) {
      promises.push(this.DeleteFoodItem(id));
    }
    await Promise.all(promises);
  }

  DeleteFoodItem(id: number) {
    return new Promise((resolve, reject) => {
      this.api.delete(`food-plan/${id}/food`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          resolve(true);
        }
        resolve(false);
      });
    });
  }

  List() {
    return this.items;
  }

  Load(user_id, force: boolean = false) {
    return new Promise((resolve, reject) => {
      if (this.items.length === 0 || force) {
        this.LoadFromApi(user_id).then((data: FoodPlanModel[]) => {
          this.items = data;
          this.Sort();
          resolve(this.items);
        });
      }
      else {
        resolve(this.items);
      }
    });
  }

  LoadFoodItems(foodPlan: FoodPlanModel) {
    return new Promise((resolve, reject) => {
      this.api.get(`food-plan/${foodPlan._id}/food`).subscribe((data) => {
        const arr = data.json();

        let obj: any[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            FoodPlanFoodId: item.id,
            FoodPlanId: foodPlan._id,
            IsMeal: item.is_meal,
            MealId: item.meal_id,
            FoodId: item.food_id,
            Time: moment(item.time, 'H:mm:ss').format('HH:mm'),
            Name: item.name,
            Brand: item.brand !== '' ? item.brand : 'custom meal',
            Portion: item.portion,
            Serving: Number(item.serving),
            ServingSize: item.serving_size,
            Nutrition: {
              Calories: Number(item.calories),
              Fat: Number(item.fat),
              Carbohydrates: Number(item.carbohydrates),
              Protein: Number(item.protein)
            }
          });
        }

        // sort food by time
        obj.sort((a: any, b: any) => {
          if (moment(a.Time, 'HH:mm') > moment(b.Time, 'HH:mm')) return 1;
          else if (moment(a.Time, 'HH:mm') < moment(b.Time, 'HH:mm')) return -1;
          else return 0;
        });

        foodPlan.FoodItems = obj;

        this.items.map(x => {
          if (x._id === foodPlan._id) x = foodPlan;
        });

        resolve(foodPlan);
      });
    });
  }

  Remove(item: FoodPlanModel) {
    return new Promise((resolve, reject) => {
      this.api.delete(`food-plan/${item._id}`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          this.items = this.items.filter(m => m._id !== item._id);
          resolve(this.items);
        }
      });
    });
  }

  Save(user: UserModel, item: FoodPlanModel, saveFood: boolean = true) {
    return new Promise((resolve, reject) => {

      // declare new food plan
      let newItem: any = {
        _id: item._id || null,
        UserId: user._id,
        Name: item.Name,
        Notes: item.Notes || null
      };

      // insert or update food plan
      this.api.post('food-plan/', newItem).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          newItem._id = data.id;
          newItem.FoodItems = [];

          if (saveFood) {

            // each food item in meal
            item.FoodItems.map((elem: any, j) => {

              // add food items
              newItem.FoodItems.push({
                FoodPlanFoodId: elem.FoodPlanFoodId || 0,
                FoodPlanId: newItem._id,
                Time: moment(elem.Time, 'hh:mm A').format('HH:mm'),
                MealId: elem.MealId,
                FoodId: elem.FoodId,
                Serving: elem.Serving,
              } as any);
            });

            this.api.post('food-plan/food', newItem.FoodItems).subscribe((res) => {
              const data = res.json();
              if (data.success) {
                resolve(newItem);
              }
            });
          }
          else {
            resolve(newItem);
          }
        }
      });
    });
  }

  Sort() {

    // sort food plans by Name
    this.items.sort((a: FoodPlanModel, b: FoodPlanModel) => {
      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
      else if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
      else return 0;
    });

    return this.items;
  }

  private LoadFromApi(user_id) {
    return new Promise((resolve, reject) => {
      this.api.get(`food-plan/${user_id}`).subscribe((data) => {
        const arr = data.json();

        let obj: FoodPlanModel[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            _id: item.id,
            Name: item.name,
            Notes: item.notes,
            Nutrition: {
              Calories: Number(item.calories),
              Fat: Number(item.fat),
              Carbohydrates: Number(item.carbohydrates),
              Protein: Number(item.protein)
            }
          } as FoodPlanModel);
        }

        resolve(obj);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/food-plan/food-plan.ts